export const GET_AGENT_LIST = "GET_AGENT_LIST";
export const GET_AGENT_BRANDS = "GET_AGENT_BRANDS";
export const RESET_AGENT_BRANDS = "RESET_AGENT_BRANDS";
